import _isNil from 'lodash/isNil';
import 'urlpattern-polyfill';

export const KoruRoutes = {
    login: {
        href: '/login',
    },
    version: {
        href: '/version',
    },
    root: {
        href: ':organizationId?/:teamId?',
        getUrl: (organizationId?: string, teamId?: string) => {
            if (!organizationId) {
                return '/';
            } else {
                return !teamId
                    ? `/${organizationId}`
                    : `/${organizationId}/${teamId}`;
            }
        },
    },
    workbenchRoot: {
        href: ':projectId',
        getUrl: (
            organizationId: string,
            teamId: string,
            projectId: string | number
        ) => {
            return `/${organizationId}/${teamId}/${projectId}`;
        },
        getWorkbenchUrl: (
            workbenchName: string,
            organizationId: string,
            teamId: string,
            projectId: number | string,
            folderIds?: string | Array<string>
        ) => {
            let parsedFolderIds = folderIds;
            if (Array.isArray(parsedFolderIds)) {
                parsedFolderIds = parsedFolderIds.join(',');
            }

            const folderIdsString =
                _isNil(parsedFolderIds) || parsedFolderIds === ''
                    ? ''
                    : `/${parsedFolderIds}`;

            return `${KoruRoutes.workbenchRoot.getUrl(
                organizationId,
                teamId,
                projectId
            )}/${workbenchName}${folderIdsString}`;
        },
    },
    project: {
        href: 'project/:folderIds?/:poleId?',
        getUrl: (
            organizationId: string,
            teamId: string,
            projectId: string | number,
            folderIds?: string | Array<string>,
            poleId?: string
        ) => {
            const poleIdStr = poleId ? `/${poleId}` : '';
            return `${KoruRoutes.workbenchRoot.getWorkbenchUrl(
                'project',
                organizationId,
                teamId,
                projectId,
                folderIds
            )}${poleIdStr}`;
        },
        matcher: new URLPattern({
            pathname: `/:organizationId/:teamId/:projectId/project*`,
        }),
    },
    // qc: {
    //     href: 'qc/:folderIds?',
    //     getUrl: (
    //         organizationId: string,
    //         teamId: string,
    //         projectId: string | number,
    //         folderIds?: string | Array<string>
    //     ) => {
    //         return KoruRoutes.workbenchRoot.getWorkbenchUrl(
    //             'qc',
    //             organizationId,
    //             teamId,
    //             projectId,
    //             folderIds
    //         );
    //     },
    //     matcher: new URLPattern({
    //         pathname: `/:organizationId/:teamId/:projectId/qc*`,
    //     }),
    // },
    qc: {
        href: 'qc/:folderIds?',
        getUrl: (
            organizationId: string,
            teamId: string,
            projectId: string | number,
            folderIds?: string | Array<string>
        ) => {
            return KoruRoutes.workbenchRoot.getWorkbenchUrl(
                'qc',
                organizationId,
                teamId,
                projectId,
                folderIds
            );
        },
        matcher: new URLPattern({
            pathname: `/:organizationId/:teamId/:projectId/qc*`,
        }),
    },
};
